import icon from "../../assets/resolution.svg";
import type { Property } from "../../types";

export const cameraReader: Property = {
  id: "cameraReader",
  title: "cameraReader.title",
  icon,
};
